import React from 'react';
import PropTypes from 'prop-types';


export class TokenDetail extends React.Component {
  static propTypes = {
    destination: PropTypes.object.isRequired
  }
  render() {
    const { destination } = this.props;
    return (
      <div className='destination'>
        <div className='heading'>
          <strong>{destination.description}</strong>
        </div>
        <div className='grid flex token-details'>
          <TokenEndpoint destination={destination}/>
          <div className='grid-cell'>
            <p>
              <strong>Example:</strong>
              <pre><code>$ curl -u :{destination.ingestionToken} \{"\n"}
                {"    "}-H "Content-Type: application/json" \{"\n"}
                {"    "}-d '{`{"hello": "world"}`}' \{"\n"}
                {"    "}https://{destination.tokenEndpoint}/v1/log</code></pre>
            </p>
            <p className="help-link">
              <strong>Need help sending logs?</strong>
              <a href="https://documentation.solarwinds.com/en/Success_Center/papertrail/Content/kb/how-it-works/log-destinations.htm#token-based-destination">Learn more (with examples) in this help article »</a>
            </p>
          </div>
        </div>
      </div>
    )
  }
}

class TokenEndpoint extends React.Component {
  render() {
    const { destination } = this.props;
    return (
      <div className='grid-cell'>
        <p>
          <strong>Endpoint:</strong>
          <code>https://{destination.tokenEndpoint}/v1/log</code>
        </p>
        <p>
          <strong>Endpoint for bulk events:</strong>
          <code>https://{destination.tokenEndpoint}/v1/logs</code>
        </p>
        <p>
          <strong>Token:</strong>
          <code>{destination.ingestionToken}</code>
        </p>
      </div>
    )
  }
}

class Token extends React.Component {
  static propTypes = {
    destination: PropTypes.object.isRequired
  };

  render() {
    const { destination } = this.props;

    return (
      <div className="destination">
        <div className="heading">
          <div className="grid flex">
            <div className="grid-cell self-middle">
              <strong>{destination.description}</strong>
            </div>
            <div className="grid-cell self-middle btn-links sm">
              <a href={`/destinations/${destination.id}/edit`}>Settings</a>
              {' '}
              <a href={`/destinations/${destination.id}/filter`}>Log Filters</a>
            </div>
          </div>
        </div>

        <div className="grid flex token-details">
          <div className="grid-cell">
            <ul className="soft bullets">
              <li dangerouslySetInnerHTML={{ __html: destination.relatedSystems }} />
              <li dangerouslySetInnerHTML={{ __html: destination.groupLink }} />
              <li>{destination.autoadd}</li>
              <li>{destination.protocolDescription}</li>
              {destination.filterDisabled &&
                <li>
                  <span className="red">
                    <span className="flaticon solid slim"></span>
                    <a className="red" href={`/destinations/${destination.id}/filter`}>Log filter has been disabled</a>
                  </span>
                </li>
              }
              {!destination.filterDisabled && destination.filter && <li>Log filter active</li>}
              {!destination.filterDisabled && !destination.filter && destination.hasFilters && <li>Log filter inactive</li>}
            </ul>
          </div>
          <TokenEndpoint destination={destination} />
        </div>
      </div>
    );
  }
};

export default Token;
